<div class="modal-dialog modal-xl modal-content" [ngClass]="{ 'bording': action == 'create_user' }">
    <div *ngIf="action == 'create_user'" class="modal-header">
        <div><h2 class="modal-title">Create new User</h2></div>
    </div>
    <div class="modal-body" >
        <div fxLayout="row" fxLayout.xs="column">
            <div fxFlex="33.33" style="padding: 0 10px 0 10px;">
                <div fxLayout="row" class="class-mat-field">
                     <div class="label-style" fxFlex="30%">Country</div>
                    <div fxFlex="70%">
                        <mat-select placeholder="Country" [formControl]="countryControl">
                            <mat-option [value]="element['id']" *ngFor="let element of countryData; let i = index">{{element['name']}}: {{element['full_name']}}</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" class="element-style">
                    <div class="label-style" fxFlex="30%">First Name</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="firstNameControl" placeholder="First Name" style="margin: 0;">
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" class="element-style">
                    <div class="label-style" fxFlex="30%">Last Name</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="lastNameControl" placeholder="Last Name" style="margin: 0;">
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" class="element-style">
                    <div class="label-style" fxFlex="30%">Manager</div>
                    <div fxFlex="70%">
                        <mat-select [formControl]="userManagerControl" placeholder="User Manager" (selectionChange)="onManagerChange($event.value)">
                            <input class="col-input-filter" [formControl]="userManagerSearchControl">
                            <mat-select-trigger>{{ selectedUserManager?.full_name || 'User Manager' }}</mat-select-trigger>
                            <mat-option [value]="0">Choose</mat-option>
                            <mat-option *ngFor="let user of usersManager" [value]="user.id">
                                <span class="option-user"><span class="avatar small-avatar" [style.background]="user.color || '#016F86'">{{ user.initials }}</span><span><strong>{{ user.full_name }}</strong><small>{{ user.email }} · {{ user.phone }}</small></span></span>
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" class="element-style">
                    <div class="label-style" fxFlex="30%">Email</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="emailControl" placeholder="Email" style="margin: 0;">
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" class="element-style">
                    <div class="label-style" fxFlex="30%">Phone</div>
                    <div fxFlex="70%">
                        <input type="tel" class="col-input" [formControl]="phoneControl" (input)="onPhoneInput($event)" placeholder="Phone" style="margin: 0;">
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" fxLayout.xs="column">
                    <div class="label-style" fxFlex="30">Password</div>
                    <div fxFlex="70">
                        <input class="col-input" [formControl]="passwordControl" placeholder="Password">
                    </div>
                </div>
            </div>
            <div fxFlex="33.33" style="padding: 0 10px 0 10px;">
                <div fxLayout="row" class="element-style">
                    <div class="label-style" fxFlex="30%">Promo Code</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="promoCodeControl" placeholder="Promo Code" style="margin: 0;">
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" class="element-style">
                    <div class="label-style" fxFlex="30">Privilege</div>
                    <div fxFlex="70">
                        <mat-select placeholder="Privilege" [formControl]="privilegeLevelControl">
                            <mat-option [value]="1" >Level 1</mat-option>
                            <mat-option [value]="2" >Level 2</mat-option>
                            <mat-option [value]="3" >Level 3</mat-option>
                            <mat-option [value]="4" >Level 4</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" class="element-style">
                    <div class="label-style" fxFlex="30">Function</div>
                    <div fxFlex="70">
                        <mat-select placeholder="Function" [formControl]="funcionControl">
                            <mat-option [value]="element['id']" *ngFor="let element of functionData; let i = index">{{element['name']}}</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div fxLayout="row" style="padding-top: 15px;" fxLayout.xs="column">
                    <div class="label-style" fxFlex="30">Acquisition Amount</div>
                    <div fxFlex="70">
                        <input class="col-input" [formControl]="contentAcquisitionControl" type="number" min="0" step="0.01" placeholder="Ex. 200,00 FCFA">
                    </div>
                </div>
                <div fxLayout="row" class="element-style" style="padding-top: 15px;">
                    <div class="label-style" fxFlex="30%">Classification Amount</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="contentClassificationControl" type="number" min="0" step="0.01" placeholder="Ex. 200,00 FCFA" style="margin: 0;">
                    </div>
                </div>
                <div fxLayout="row" class="element-style" style="padding-top: 15px;">
                    <div class="label-style" fxFlex="30%">Edition Amount</div>
                    <div fxFlex="70%">
                        <input class="col-input" [formControl]="contentEditionControl" type="number" min="0" step="0.01" placeholder="Ex. 200,00 FCFA" style="margin: 0;">
                    </div>
                </div>
            </div>
            <div fxFlex="33.33" style="padding: 0 10px 0 10px;">
                <div fxLayout="row" fxLayout.xs="column">
                    <div fxFlex="33.33" style="padding-top: 20px;">
                        <div>
                            <h3>Enovsky</h3>
                            <div style="position: relative; display: flex; margin-left: auto; align-items: center; padding-top: 10px;" *ngFor="let page of enovskyPages">
                                <input class="form-check-input" [checked]="rowInfos['authorization']?.['enovsky']?.includes(page['id_page']) ?? false" style="font-size:large; cursor: pointer; " type="checkbox" role="switch" (change)="checkPage('enovsky', page, $event.target)">
                                <span style="padding-left: 24px;">{{page['name']}}</span>
                            </div>
                        </div>
                        
                    </div>
                    <div fxFlex="33.33" style="padding-top: 20px;">
                        <h3>Virtual Campus</h3>
                        <div style="position: relative; display: flex; margin-left: auto; align-items: center; padding-top: 10px;" *ngFor="let page of virtualCampusPages">
                            <input class="form-check-input" [checked]="rowInfos['authorization']?.['virtualcampus']?.includes(page['id_page']) ?? false" style="font-size:large; cursor: pointer; " type="checkbox" role="switch" (change)="checkPage('virtualcampus', page, $event.target)">
                            <span style="padding-left: 24px;">{{page['name']}}</span>
                        </div>
                    </div>
                    <div fxFlex="33.33" style="padding-top: 20px;">
                        <h3>Virtual Class</h3>
                        <div style="position: relative; display: flex; margin-left: auto; align-items: center; padding-top: 10px;" *ngFor="let page of virtualClassPages">
                            <input class="form-check-input" [checked]="rowInfos['authorization']?.['virtualclass']?.includes(page['id_page']) ?? false" style="font-size:large; cursor: pointer; " type="checkbox" role="switch" (change)="checkPage('virtualclass', page, $event.target)">
                            <span style="padding-left: 24px;">{{page['name']}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="padding-top: 15px;"></div>
        <div *ngIf="action == 'update_user'">
            <div fxLayoutAlign="center center">
                <button class="button-validate-small" (click) = "applyUpdate()">Update User</button>
            </div>
        </div>
        

    </div>
    <div *ngIf="action == 'create_user'" style="padding: 15px;">
        <hr>
        <div class="modal-footer" style="margin-top: 5px;">
            <button type="button" class="button-secondary-small" (click)="closeDialog()">Close</button>
            <button type="button" class="button-validate-small" (click)="applyUpdate()" style="margin-right: 8px;">Create User</button>
        </div>
    </div>
</div>